<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Clean',
  mounted() {
    this.$ls.clear();
    this.setHomeData(false);
    this.$router.push('/');
  },
  methods: {
    ...mapActions(['setHomeData']),
  },
};
</script>
